// client/src/pages/sections/groups/ClientChip.js
// A client's code and name together, as one pill — so a partner never has to look a code up.
//
//   <ClientChip code="00069-001" name="Acme, LLC" />   name optional: a code the page has already seen (issue members,
//                                                     the signer-group review, the anchor pickers) is looked up here.
//   rememberClientNames(rows)                          call with whatever the page just loaded; rows are anything with a
//                                                     code and a name under the usual keys (see KEYS).
//   clientNameFor(code)                                the remembered name, or null.
//
// The registry is module-level and filled BEFORE the data that mentions the code is rendered (same shape as
// clientRosterCache.js), so the chip reads it synchronously and needs no subscription.

const names = new Map();

const KEYS = [['code', 'name'], ['clientCode', 'clientName'], ['sgCode', 'sgName'], ['anchorCode', 'anchorName'],
  ['sgParentCode', 'sgParentName'], ['rgAnchorCode', 'anchorName'], ['primaryClientCode', 'primaryClientName'],
  ['nlcClientCode', 'nlcClientName']];

export function rememberClientNames(rows) {
  const walk = (r, depth) => {
    if (!r || typeof r !== 'object' || depth > 5) return;
    if (Array.isArray(r)) { r.forEach(x => walk(x, depth + 1)); return; }
    for (const [ck, nk] of KEYS) {
      const c = r[ck], n = r[nk];
      if (typeof c === 'string' && typeof n === 'string' && c.trim() && n.trim()) names.set(c.trim(), n.trim());
    }
    // members / groups / anchors nested in an issue, a review row or a response
    for (const v of Object.values(r)) if (v && typeof v === 'object') walk(v, depth + 1);
  };
  walk(rows, 0);
}

export function clientNameFor(code) {
  return (code && names.get(String(code).trim())) || null;
}

export default function ClientChip({ code, name, className = '', title }) {
  if (!code) return null;
  const shown = name || clientNameFor(code);
  return (
    <span className={`cg-client-chip ${className}`.trim()} title={title || (shown ? `${code} — ${shown}` : code)}>
      <code className="cg-client-chip-code">{code}</code>
      {shown && <span className="cg-client-chip-name">{shown}</span>}
    </span>
  );
}
